"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationArrowWidth = void 0;
/**
 * Decides `width` of navigation button based on `navigation.size`.
 *
 * @param param0 object containing `size` attribute from `navigation`.
 * @returns `width` of navigation button.
 */
const getNavigationArrowWidth = ({
  size
}) => size === 'small' ? 24 : 60;
exports.getNavigationArrowWidth = getNavigationArrowWidth;
